export default "__VITE_ASSET__69b94004__"